import * as actionTypes from './../Register_action.types';
import * as api from './../register_api_services/Leave.api';


export const CreateLeaveMasterRequest = (fileData) => ({
  type: actionTypes.CREATE_LEAVE_MASTER_REQUEST,
  payload: fileData,
});

export const CreateLeaveMasterSuccess = (message) => ({
  type: actionTypes.CREATE_LEAVE_MASTER_SUCCESS,
  payload: message,
});

export const CreateLeaveMasterFailure = (error) => ({
  type: actionTypes.CREATE_LEAVE_MASTER_FAILURE,
  payload: error,
});

export const createLeaveMaster = (leaveData) => {
  return async (dispatch) => {
    dispatch(CreateLeaveMasterRequest(leaveData));
    try {
      const response = await api.createLeaveMaster(leaveData);
      dispatch(CreateLeaveMasterSuccess(response));
      return { success: true, message: response };
    } catch (error) {
      dispatch(CreateLeaveMasterFailure(error));
      return { success: false, message: error };
    }
  };
};


export const getLeaveRequest = () => ({
  type: actionTypes.GET_LEAVE_MASTER_REQUEST,
});

export const getLeaveSuccess = (leave) => ({
  type: actionTypes.GET_LEAVE_MASTER_SUCCESS,
  payload: leave,
});

export const getLeaveFailure = (error) => ({
  type: actionTypes.GET_LEAVE_MASTER_FAILURE,
  payload: error,
});

export const getLeaveMaster = () => {
  return async (dispatch) => {
    dispatch(getLeaveRequest());
    try {
      const leaves = await api.fetchLeaveData();
      dispatch(getLeaveSuccess(leaves));
      return { success: true, data: leaves };
    } catch (error) {
      dispatch(getLeaveFailure(error));
      return { success: false, message: error };
    }
  };
};

export const updateLeaveRequest = (id, leaveData) => ({
  type: actionTypes.UPDATE_LEAVE_MASTER_REQUEST,
  payload: { id, leaveData },
});

export const updateLeaveSuccess = (message) => ({
  type: actionTypes.UPDATE_LEAVE_MASTER_SUCCESS,
  payload: message,
});

export const updateLeaveFailure = (error) => ({
  type: actionTypes.UPDATE_LEAVE_MASTER_FAILURE,
  payload: error,
});

export const updateLeaveById = (id, leaveData) => {
  return async (dispatch) => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    leaveData.updated_by = user.user_name;

    dispatch(updateLeaveRequest(id, leaveData));
    try {
      const response = await api.updateLeave(id, leaveData);
      dispatch(updateLeaveSuccess(response.message));
      return { success: true, message: response.message };
    } catch (error) {
      dispatch(updateLeaveFailure(error));
      return { success: false, message: error };
    }
  };
};




export const deleteLeaveRequest = (id) => ({
  type: actionTypes.DELETE_LEAVE_MASTER_REQUEST,
  payload: id,
});

export const deleteLeaveSuccess = (message) => ({
  type: actionTypes.DELETE_LEAVE_MASTER_SUCCESS,
  payload: message,
});

export const deleteLeaveFailure = (error) => ({
  type: actionTypes.DELETE_LEAVE_MASTER_FAILURE,
  payload: error,
});

export const deleteLeaveById = (id) => {
  return async (dispatch) => {
    dispatch(deleteLeaveRequest(id));
    try {
      const response = await api.deleteLeave(id);
      dispatch(deleteLeaveSuccess(response.message));
      return { success: true, message: response.message };
    } catch (error) {
      dispatch(deleteLeaveFailure(error));
      return { success: false, message: error };
    }
  };
};


export const uploadLeaveMasterRequest = (fileData) => ({
  type: actionTypes.UPLOAD_LEAVE_MASTER_REQUEST,
  payload: fileData,
});

export const uploadLeaveMasterSuccess = (message) => ({
  type: actionTypes.UPLOAD_LEAVE_MASTER_SUCCESS,
  payload: message,
});

export const uploadLeaveMasterFailure = (error) => ({
  type: actionTypes.UPLOAD_LEAVE_MASTER_FAILURE,
  payload: error,
});

export const uploadLeaveMasterFile = (fileData) => {
  return async (dispatch) => {
    dispatch(uploadLeaveMasterRequest(fileData));
    try {
      const response = await api.leaveMasterDataUpload(fileData);
      // showSnackbar(response, 'success');
      dispatch(uploadLeaveMasterSuccess(response));
      return { success: true, data: response };
    } catch (error) {
      dispatch(uploadLeaveMasterFailure(error));
      return { success: false, message: error };
    }
  };
};

export const multiDaleteLeaveMasterRequest = (ids) => ({
  type: actionTypes.MULTIDELETE_LEAVE_MASTER_REQUEST,
  payload: ids,
});

export const multiDaleteLeaveMasterSuccess = (message) => ({
  type: actionTypes.MULTIDELETE_LEAVE_MASTER_SUCCESS,
  payload: message,
});

export const multiDaleteLeaveMasterFailure = (error) => ({
  type: actionTypes.MULTIDELETE_LEAVE_MASTER_FAILURE,
  payload: error,
});

export const multiDeleteLeaveMaster = (ids) => {
  return async (dispatch) => {
    dispatch(multiDaleteLeaveMasterRequest(ids));
    try {
      const response = await api.multiDeleteLeaveMaster(ids);
      // showSnackbar(response, 'success');
      dispatch(multiDaleteLeaveMasterSuccess(response));
      return { success: true, message: response };
    } catch (error) {
      dispatch(multiDaleteLeaveMasterFailure(error));
      return { success: false, message: error };
    }
  };
};
